import PhoneInputWithCountry2 from '../../components/common/phoneinput2';
import { MantineGrid, MantineGridColumn } from '../../components/mantine/grid';
import MantineTextInput from '../../components/mantine/textinput';
import { PlaceholderUi } from '../../helpers/common';

const ProfileField = ({ label, formvalues, value, inputName, editable }: any) => {
  return (
      <>
          <MantineGridColumn span={12}>
              {inputName === "phoneNumber" ? (
                  <PhoneInputWithCountry2
                      placeholder={`Enter Your ${label}`}
                      value={!editable ? formvalues?.values[inputName] : value}
                      onChange={(value: any) => formvalues.setFieldValue(inputName, value)}
                      error={formvalues?.errors?.phoneNumber}
                      inputClass={"!w-full !mb-2 !border-current-secondary-color"}
                      containerClass={'!mb-2'}
                  />
              ) : (
                  <MantineTextInput
                      {...(!editable && formvalues?.getInputProps(inputName))}
                      // required
                      placeholder={`Enter Your ${label}`}
                      disabled={editable}
                      value={!editable ? formvalues?.values[inputName] : value}
                      onChange={(event: any) => formvalues.setFieldValue(inputName, event.currentTarget.value)}
                      classNames={{ input: `${PlaceholderUi} mb-2`, label: "text-sm", error: "absolute -bottom-4" }}
                      label={label}
                  />
              )}
          </MantineGridColumn>
      </>
  );
};

const ProfileInfo = (props:any) => {
    const { profileData, formvalues } =props
    const profileDataFilter = [
      { label: "First Name", value: profileData?.userName, inputValue: "firstName", editable: true },
      { label: "Email", value: profileData?.email, inputValue: "email", editable: true },
      { label: "Client", value: profileData?.client?.name, inputValue: "client", editable: true },
   // { label: "Contact Number", value: profileData?.phoneNumber, inputValue: "phoneNumber", editable: false, },
      { label: "Role", value: profileData?.userRole?.roleName, inputValue: "role", editable: true },
    ];
  
    // Split the fields into two columns
    const leftColumnFields = profileDataFilter.slice(0, 2);
    const rightColumnFields = profileDataFilter.slice(2);
  
    return (
      <MantineGrid p={8}>
        <MantineGridColumn span={{ md: 6 }}>
          {leftColumnFields.map((profile, index) => (
            <ProfileField
              key={index}
              label={profile.label}
              value={profile.value}
              formvalues={formvalues}
              inputName={profile.inputValue}
              editable={profile.editable}
            />
          ))}
        </MantineGridColumn>
        <MantineGridColumn span={{ md: 6 }}>
          {rightColumnFields.map((profile, index) => (
            <ProfileField
              key={index + leftColumnFields.length}
              label={profile.label}
              value={profile.value}
              formvalues={formvalues}
              inputName={profile.inputValue}
              editable={profile.editable}
            />
          ))}
        </MantineGridColumn>
      </MantineGrid>
    );
  };
  
  export default ProfileInfo;